import * as Sentry from "@sentry/react";
import React from "react";

interface ErrorBoundaryProps {
  children: React.ReactNode;
}

export default function ErrorBoundary({ children }: ErrorBoundaryProps) {
  return (
    <Sentry.ErrorBoundary
      fallback={({ resetError }) => (
        <div>
          <p>An error has occurred</p>
          <button onClick={resetError}>Try again</button>
        </div>
      )}
      beforeCapture={(scope) => {
        scope.setTag("boundary", "root");
      }}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
}
